import { FormLabelProps } from '@/components/elements/enFormLabel'

export const mediaLabels: {
  company: FormLabelProps
  fullName: FormLabelProps
  firstName: FormLabelProps
  lastName: FormLabelProps
  email: FormLabelProps
  tel: FormLabelProps
  media: FormLabelProps
  title: FormLabelProps
  detail: FormLabelProps
} = {
  company: {
    text: 'Company',
    isRequired: false,
    inputId: 'company',
  },
  fullName: {
    text: 'Name',
    isRequired: true,
    inputId: 'lastName',
  },
  firstName: {
    text: 'First name',
    isRequired: 'none',
    inputId: 'firstName',
  },
  lastName: {
    text: 'Last name',
    isRequired: 'none',
    inputId: 'lastName',
  },
  email: {
    text: 'Email Address',
    isRequired: true,
    inputId: 'email',
  },
  tel: {
    text: 'Phone Number',
    isRequired: false,
    inputId: 'tel',
  },
  media: {
    text: 'Media Name',
    isRequired: false,
    inputId: 'media',
  },
  title: {
    text: 'Subject',
    isRequired: false,
    inputId: 'title',
  },
  detail: {
    text: 'Message',
    isRequired: true,
    inputId: 'detail',
  },
}

export const formData = {
  company: '',
  lastName: 'トライアル',
  firstName: '太郎',
  email: 'XXX@XXX.ne.jp',
  tel: '00-0000-0000',
  media: '媒体名が入りますダミー',
  title: '件名が入りますダミー',
  detail:
    'ここに内容が入りますダミーです。ここに内容が入りますダミーです。ここに内容が入りますダミーです。ここに内容が入りますダミーです。ここに内容が入りますダミーです。ここに内容が入りますダミーです。ここに内容が入りますダミーです。ここに内容が入りますダミーです。ここに内容が入りますダミーです。ここに内容が入りますダミーです。ここに内容が入りますダミーです。ここに内容が入りますダミーです。ここに内容が入りますダミーです。ここに内容が入りますダミーです。',
}
